<template>
  <div class="w-100">
    <v-row v-if="!!$slots.backButton || backButton || backButtonUrl || $slots.buttons">
      <v-col class="pa-0" v-if="!!$slots.backButton || backButton || backButtonUrl">
        <slot name="backButton">
          <s-btn :to="backButtonUrl" icon-name="keyboard_backspace" />
        </slot>
      </v-col>
      <v-spacer />
      <v-col class="text-right">
        <slot name="buttons" />
      </v-col>
    </v-row>

    <v-row :dense="true" align="center" justify="space-between">
      <v-col>
        <span class="text-h6"> <slot /> </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/**
 * Show the page header with an optional back button, optional action buttons and title.
 * This component is deprecated because it is more convenient to compose the page header with small reusable components.
 * @see page-header.stories.js
 */
export default {
  name: 's-page-header',

  props: {
    backButton: { type: Boolean, default: false },
    backButtonUrl: { type: [String, Object], default: null }
  }
};
</script>
